export const Dashboard = "Dashboard";
export const Widgets = "Widgets";
export const Summary = "Summary";
export const NewsUpdate = "News & Update";
export const Appointment = "Appointment";
export const Notification = "Notification";
export const NotificationSettings = "Notification Settings";
export const addNotification = "Add Notification ";
export const editNotification = "Edit Notification ";
export const MarketValue = "Market Value";
export const Chat = "Chat";
export const logout = "Log out";
export const DiscriptionText = "Description";
// Dashboard Default
export const WelcomeWilliam = "Welcome,William";
export const Continue = "Continue";
export const DefaultdashDiscription = "You have completed 40% of your this week! Start a new goal & improve your result";
export const YearlyOverview = "Yearly Overview";
export const Monday = "Monday";
export const TransactionName = "Transaction";
export const StockValue = "$5263.04";
export const BeyondtheLines = "Beyond the Lines";
export const BeyondtheLinespara = "One Of the world,s brightest, young surf Srars, Kanoa lgarashi.";
export const hoursago6 = "6 hours ago";
export const june = "june";
export const TotalInvestment = "Total Investment";
export const TotalGain = "Total Gain";
export const Profitin6months = "Profit in 6 months";
export const noBookmarktext = "Opps!! There are no result found.";
export const CustomerFeedback = "Customer Feedback";
export const Positive = "Positive";
export const Negative = "Negative";
export const Mob = "Mob";
export const TopSocialMedia = "Top Social Media Shared";
export const Buymorespace = "Buy more space now!";
export const InviteFriends = "Invite 2 Friends and get 5 GB extra space.";
export const Upgradenow = "Invite now";

export const NewProduct = "New Product";
export const Location = "Location";
export const RiskFactor = "Risk Factor";
export const BestSeller = "Best Seller";
export const ItemName = "Item Name";
export const DateandTime = "Date and Time";
export const Income = "Income";

export const Earnings = "Earnings";
export const Products = "Products";
export const Messages = "Messages";
export const Settings = "Settings";
export const NewUser = "New User";
export const Users = "Users";
export const Shareit = "Share It";
export const Raymond = "Raymond";
export const STEP = 10;
export const MIN = 10;
export const MAX = 1250;

export const New = "New";
export const Pending = "Pending";
export const Done = "Done";
export const Doing = "Doing";
export const Smooth = "Smooth";
export const Running = "Running";
export const Cancel = "Cancel";
export const Subscription = 'Subscription';
export const Companies = 'Companies';
export const Invoice = 'Invoice';
export const DueDate = 'Due Date';
export const InvoiceDate = 'Invoice Date';
export const BillingTo = 'Billing To:';
export const Txn = 'Txn#';
export const TaxIn = 'Tax In';

export const kolkata_India = "kolkata, India";
export const India_Surat = "India, Surat";
export const RecentActivity = "Recent Activity";
export const Profit = "Profit";
export const Loss = "Loss";
export const MarkJecno = "Mark Jecno";
export const JennyGester = "Jenny Gester";
export const Manager = "Manager";
export const Follower = "Follower";
export const Followers = "Followers";
export const Following = "Following";
export const Followings = "Followings";
export const TotalPost = "Total Post";
export const NewOrder = "New Order";

export const Facebooks = "Facebook";
export const Twitters = "Twitter";
export const Linkedins = "Linkedin";
export const GooglePlus = "Google +";
export const Github = "Github";

export const Daily = "Daily";
export const Weekly = "Weekly";
export const Yearly = "Yearly";
export const Monthly = "Monthly";
export const Hot = "Hot";
export const Date = "Date";
export const DateTxt = "Date";
export const Month = "Month";
export const Week = "Week";
export const Time = "Time";
export const Sale = "Sale";
export const Year = "Year";
export const Today = "Today";
export const Day = "Day";
export const JohnLoren = "John Loren";
export const myfavorite = "Out is my favorite";
export const VenterLoren = "Venter Loren";
export const Tomorrow = "Tomorrow";
export const Yesterday = "Yesterday";
export const RightNow = "Right Now";
export const Last7Days = "Last 7 Days";
export const Last30Days = "Last 30 Days";

export const TodayTotalSale = "Today Total sale";
export const TodayTotalVisits = "Today Total visits";
export const OurSaleValue = "Our Sale Value";
export const TodayStockValue = "Today Stock Value";
export const TotalProfit = "Total Profit";
export const HikeShoes = "Hike Shoes";
export const CouponCode = "coupon code";
export const TreePot = "Tree Pot";
export const Bag = "Bag";
export const Watch = "Watch";
export const TShirt = "T-shirt";
export const TotalGoal = "Total Goal";
export const GoalArchive = "Goal Archive";
export const DownloadDetails = "Download details";
export const Peris = "Peris";

export const Johnketer = "John keter";
export const HerryVenter = "Herry Venter";
export const LoainDeo = "loain deo";
export const HorenHors = "Horen Hors";
export const InProcess = "In Process";
export const InProgress = "In Progress";
export const FenterJessy = "fenter Jessy";

export const ReferralEarning = "Referral Earning";
export const CashBalance = "Cash Balance";
export const Balance = "Balance";
export const SalesForcasting = "Sales Forcasting";
export const Sales = "Sales";
export const Store = "Store";
export const Online = "Online";

export const SalesReturn = "Sales Return";
export const PurchaseRet = "Purchase Ret";
export const PurchaseOrderValue = "Purchase Order Value";
export const ProductOrderValue = "Product Order Value";

export const ProductCart = "Product Cart";
export const RecenetActivity = "Recent Activity";
export const Sale_Details = "Sale Details";
export const Browser_Uses = "Browser Uses";
export const Total_Earning = "Total Earning";
export const Pepe_Jeans = "Pepe-Jeans";
export const Celio = "Celio";
export const SalesByCountries = "Sales By Countries";
export const SalesByState = "Sales By State";
export const APRIL = "APRIL";
export const Imustexplain = "I must explain to you how? ";
export const Caldesc = "We are excited about continuing to build a complete ecosystem around value commerce, where we can serve Bharat consumers wherever they are on their shopping journey. Our mission is to become India’s value lifestyle omni-channel leader.";
export const browser = "Browser";
export const Qtyd = "Qty.";

export const ProductDetail = "I love this good looking shoes, but comfort is where it’s at for Me. I can’t say how well they are for playing football , but for everyday wear they are amazing. I think they’re more comfortable than My lebron 17s.";
export const JohannaParvez = "Johanna Parvez";

export const Enquiry = "Enquiry";
export const enquiryDetails = "Enquiry Details";
export const newEnquiry = "New Enquiry";
export const editEnquiry = "Edit Enquiry";
export const EnquiryList = "Enquiry List";
export const Addtoleads = "Add to leads";
export const Import = "Import";
export const Export = "Export";


export const Details = "Details";
export const Quantity = "Quantity";
export const Hours = "Hours";
export const Status = "Status";
export const PaymentStatus = "Payment Status";
export const Price = "Price";
export const MRP = "MRP";
export const MinConnection = "Min Connection";
export const MinConnectionError = "Min Connection req";
export const MaxConnection = "Max Connection";
export const MaxConnectionError = "Max Connection Required";
export const MinimumPrice = "Min Price";
export const MinimumPriceError = "Minimum Price is required";
export const Rate = "Rate";
export const HST = "HST";
export const Weigth = "Weigth";

export const Employee_Status = "Employee Status";
export const Name = "Name";
export const Designation = "Designation";
export const SkillLevel = "Skill Level";
export const Experience = "Experience";

export const ContactUs = "Contact Us";
export const Contact = "Contact";
export const YourName = "Your Name";
export const Email = "Email";
export const Message = "Message";
export const PrivacyPolicy = "Privacy Policy";
export const Agreewith = "Agree with";
export const SEND_IT = "SEND IT";
export const Topproducts = "Top Products";
export const Recentpayments = "Recent Payments";
export const Recentsubscribers = "Recent Subscribers";
export const Bestsellers = "Best Sellers";
export const ExpiredSubscription = "Expired Subscription";
export const ExpiresToday= "Expires Today";
export const PaymentDues= "Payment Due";
export const SpecialWeekend = "Special Weekend Offer";
export const Upto50Discount = "Upto 50% Off Discount";
export const SeeMore = "See More";

// dashboard charts

export const Activity = "Activity";

export const SALE = "SALE";
export const PROJECTS = "PROJECTS";
export const PRODUCTS = "PRODUCTS";

export const MarketingExpenses = "Marketing Expenses";
export const TotalSales = "Total sales";
export const TotalPurchase = "Total purchase";
export const TotalEarning = "Total Earning";
export const skillStatus = "Skill Status";
export const orderStatus = "Order Status";

export const LiveProducts = "Live Products";
export const Turnover = "Turnover";
export const MonthlySales = "Monthly Sales";

export const Uses = "Uses";
export const BrowserUses = "Browser Uses";
export const Finance = "Finance";

// Project

export const ProjectTitle = "Project Title";
export const ClientName = "Client name";
export const ProjectRate = "Project Rate";

export const ProjectType = "Project Type";
export const ProjectStatus = "Project Status";
export const Priority = "Priority";
export const ProjectSize = "Project Size";
export const Small = "Small";
export const Medium = "Medium";
export const Big = "Big";
export const Low = "Low";
export const High = "High";
export const Urgent = "Urgent";

export const StartingDate = "Starting date";
export const EndingDate = "Ending date";
export const EnterSomeDetails = "Enter some Details";
export const UploadProjectFile = "Upload project file";
export const Add = "Add";
export const CreateNewProject = "Create New Project";
export const Hourly = "Hourly";
export const FixPrice = "FixPrice";

export const Issues = "Issues";
export const Resolved = "Resolved";
export const Comment = "Comment";

// ecommerce

export const Filters = "Filters";
export const ShowingProducts = "Showing Products 1 - 24 Of 200 Results";
export const Featured = "Featured";
export const LowestPrices = "Lowest Prices";
export const HighestPrices = "Highest Prices";
export const NotFoundData = "Sorry, We didn't find any results matching this search";
export const ProductDetails = "Product Details";
export const AddToCart = "Add To Cart";
export const BuyNow = "Buy Now";
export const ContinueShopping = "Continue shopping";
export const ViewDetails = "View Details";
export const OutOfStock = "Out Of Stock";
export const InStock = "In Stock";
export const Pixelstrap = "Pixelstrap";
export const ABC = "ABC";
export const Fabric = "Fabric";
export const Cotton = "Cotton";
export const AddToWishList = "AddToWishList";
export const Show = "Show";
export const AllAbout = "About 6,000 results (0.60 seconds)";
export const ImageAbout = "About 12,120 results (0.50 seconds)";

export const ProductSizeArray = ["M", "L", "Xl"];

export const Fusion = "Fusion white & blue printed regular fit asymmetric";
export const ProductReview = "(250 review)";
export const ProductPageDetails = "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck I Regular Wear Solid Kids Tees and Black Sleeve..";
export const Febric = "Febric";
export const Brand = "Brand Icons";
export const Availability = "Availability";
export const ProductImage = "Product Image";
export const SelectSize = "Select Size";
export const Size = "Size";

export const ProductListTitle = "Individual column searching (text inputs)";
export const ProductListDesc = "The searching functionality provided by DataTables is useful for quickly search through the information in the table - however the search is global, and you may wish to present controls that search on specific columns.";
export const Discription1 = "Refresh your wardrobe with this chic top. With an eye-catching square neck, this top also features pretty puff sleeves. Stunning pink colour Classic solid pattern Square neck Elasticated puff sleeves Belt included, Polyester fabric, machine wash..";
export const Discription2 = "Tee Stores is an Indian contemporary clothing brand. The product pages display a fine quality fabric with colorful description. We offer many vivid designs, art, styles that combine heritage with modernity, simplicity, playfulness and street style";
export const Discription3 = "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.";
export const Discription4 = "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck I Regular Wear Solid Kids Tees and Black Sleeve.";
export const Discription =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
export const Productdlt = "350.00";
export const scrollpara = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.";
export const scrollpara1 = "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum";
export const scrollpara2 = "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words";
export const scrollpara3 = "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.";

export const CreditCard = "Credit card";
export const DebitCard = "Debit card";
export const ExpirationDate = "Expiration Date";
export const COD = "COD";
export const EMI = "EMI";
export const NetBanking = "Net Banking";
export const Submit = "Submit";
export const Womenpinkshirt = "Women Pink shirt.";
export const Aime = "aime";
export const Aliff = "aliff";
export const FreeShipping = "Free Shipping";
export const FreeShippingWorldWide = "Free Shipping World Wide";
export const ServiceTime = "24 X 7 Service";
export const OnlineService = "Online Service For New Customer";
export const SelectType = "Select Type";
export const Master = "Master";
export const Visa = "Visa";

export const SelectMonth = ["Select Month", "Jan", "Fab", "March", "April"];
export const SelectYear = ["Select Year", "2015", "2016", "2017", "2021", "2022"];
export const BankName = ["Select Bank", "SBI", "ICICI", "KOTAK", "BOB"];
export const SelectCard = ["Select Card", "2", "3", "4", "5"];
export const SelectDuration = ["Select Duration", "2015-2016", "2016-2017", "2017-2021", "2021-2022"];

export const ShippedOrders = "Shipped Orders";
export const CancelledOrders = "Cancelled Orders";

export const Customer = "Customer";
export const BillingAddress = 'Billing Address';
export const GSTIN = 'GSTIN#';
export const Connection = "Connection";
export const InvoiceSeries = "Invoice series";
export const Blue = "Blue";
export const Brown = "Brown";
export const Green = "Green";
export const Black = "Black";
export const Orange = "Orange";
export const Pista = "Pista";

export const SimplePricingCard = "Simple Pricing Card";
export const BecomeMember = "Become Member";
export const Pricing = "Pricing";
export const PricingTableWithBorder = "Pricing Table With Border";
export const ColorHighlight = "Color Highlight";
export const PricingTableWithRibbons = "Pricing Table With Ribbons";
export const Standard = "Standard";
export const Business = "Business";
export const Premium = "Premium";
export const PerMonthPremium = "$5/month";
export const PremiumSpace = "200 GB Space";
export const AuthorPack = "Author Pack";
export const Extra = "Extra";
export const Pricings = "Pricing";
export const Popular = "Popular";
export const Subscribe = "Subscribe";
export const StandardPrice = "Standard Price";
export const BussinessPrice = "Business Price";
export const PremiumPrice = "Premium Price";
export const ExtraPrice = "Extra Price";
export const Purchase = "Purchase";
export const Header = "Header";
export const month = "/ month";

export const CartTitle = "Cart";
export const CartTableHeader = ["Product", "Prdouct Name", "Price", "Quantity", "Action", "Total"];

export const NewOrders = "New Orders";
export const TotalPrice = "Total Price";
export const CheckOut = "Check out";
export const CartEmpty = "Your Cart is Empty";
export const ExploreShortlistItems = "Explore more shortlist some items.";

export const WishlistTitle = "Wishlist";
export const MoveToCarts = "Move to Cart";
export const WishlistTableHeader = ["Prdouct", "Prdouct Name", "Price", "Availability", "Action"];

// sample pages
export const footerFixed = "Footer Fixed";
export const AddTaxGroup = "Add Tax Group";
export const AddTax = "Add Tax";
export const EditTax = "Edit Tax";
export const AddInvoice = "Add Invoice";
export const AddPackages = "Add Packages";
export const AddAccount = "Add Account";
export const EditAccount = "Edit Account";
export const AddRole = "Add Role";
export const AddAddons = "Add Addons";
export const Packages = "Packages";
export const Permission = "Permission";
export const EditPackages = "Edit Packages";
export const AddSubscription = "Add Subscription";
export const AddCompany = "Add Company";
export const Tax = "Tax";
export const TaxRate = "Tax Rate";
export const ExtendDays = "Extend Days";
export const CollectionAmount="Collection Amount"
export const paymentMethod="Payment Method"
export const PaymentDetail = "Payment Details";
export const Footerdark = "Footer Dark";
export const AddCoupon = "Add Coupon";
export const CouponName = "Coupon Name";
export const EditCoupon = "Edit Coupon";
export const Code = "Code";
export const StartDate = "Start Date";
export const EndDate = "End Date";
export const UsersPerCoupon = "Use Per Coupon";
export const UsersPerCustomer = "Use Per Customer";
export const AddPaymentMethod = "Add Payment Method";
export const EditPaymentMethod = "Edit Payment Method";

// check out
export const BillingDetails = "Billing Details";
export const Id = "Id";
export const Task = "Task";
export const ColorType = "Color Type";
export const FirstName = "First Name";
export const LastName = "Last Name";
export const SignalName = "Signal Name";
export const Security = "Security";
export const Performance = "Performance";
export const OrderId = "Order Id";
export const Dessert = "Dessert";
export const DessertType = "Dessert Type";
export const Calories = "Calories";
export const Fat = "Fat";
export const Stage = "Stage";
export const Schedule = "Schedule";
export const TeamLead = "Team Lead";
export const Phone = "Phone";
export const Assign = "Assign";
export const EmailAddress = "Email Address";
export const Countrys = "Country";
export const Office = "Office";
export const Salary = "Salary";
export const JoinDate = "Join Date";
export const EmployeeName = "Employee Name";
export const Sex = "Sex";
export const Game = "Game";
export const Point = "Point";

export const CountryMenu = ["India", "South Africa", "United State", "Australia"];

export const Address = "Address";
export const TownCity = "Town/City";
export const StateCountry = "State/Country";

export const PostalCode = "Postal Code";
export const CheckMeOut = "Check me out";
export const PlaceOrder = "Place Order";

export const Product = "Product";
export const Total = "Total";
export const TotalPayable = "Total Payable";
export const TotalPer = "Total %";
export const Subtotal = "Subtotal";
export const SGSTText = "SGST";
export const CGSTText = "CGST";
export const Paid = "Paid";
export const PaidOn = "Paid On";
export const Discount = "Discount";
export const Reference = "Reference";


export const Shipping = "Shipping";
export const Option1 = "Option 1";
export const Option2 = "Option 2";
export const CheckPayments = "Check Payments";
export const AddPayments = "Add Payments";
export const ApplyCoupon="Apply Coupon"
export const PaymentMethods = "Payment Methods";
export const CashOnDelivery = "Cash On Delivery";
export const PayPal = "PayPal";
export const ENDCALL = "END CALL";
export const Makevertical = "Make vertical buttons";

// filter
export const Colors = "Color";
export const NewProducts = "New Products";
export const FancyShirt = "Fancy Shirt";
export const FancyShirtPrice = "$100.00";

// invoice
export const InvoiceHash = "Invoice #";
export const InvoiceTotal = "Invoice Total";
export const Issued = "Issued: ";
export const PaymentDue = "Payment Due: ";
export const JohanDeo = "Johan Deo";
export const JohanDeoMailId = "JohanDeo@gmail.com";
export const ProductDescription = "Product Description";
export const ProjectDescriptionDetails = "You are only as good as your last collection, which is an enormous pressure. Jeans represent democracy in fashion. Fashion is about dressing according to what is fashionable..";
export const ProductName = "Product Name";
export const Item = "Items";
export const Amount = "Amount";
export const Sub_total = "Sub-total";
export const ThankBusiness = "Thank you for your business! ";
export const ThankBusinessDesc = " Payment is expected within 31 days; please process this invoice within that time. There will be a 5% interest charge per month on late invoices.";
export const Print = "Print";
export const ThermalPrint = "Thermal Print";
export const ProductCategory = "Product Category";
export const MansShirt = "Man's Shirt";
export const MansJeans = "Man's Jeans";
export const WomenTshirt = "Women T-shirt";
export const Shoes = "Shoes";
export const WomenSkirt = "Women Skirt";
export const Levis = "Levi's";
export const Hudson = "Hudson";
export const Denizen = "Denizen";
export const Spykar = "Spykar";
export const Diesel = "Diesel";
export const Red = "Red";
export const White = "White";
export const Quality = "Quality";
export const BrandNew = "Brand New";
export const SecondHand = "Second Hand";
export const BothQuality = "Both Quality";

// Users

export const MarekjecnoMailId = "Marekjecno@yahoo.com";
export const BOD = "BOD";
export const DDMMYY = "02 January 1988";
export const Designer = "designer";
export const ContactUsNumber = "India +91 123-456-7890";
export const LocationDetails = "B69 Near Schoool Demo Home";
export const JOHANDIO = "JOHAN DIO";
export const UserProfileDesc1 =
  "you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.";
export const UserProfileDesc2 =
  "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source .Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source";
export const UserProfileDesc3 =
  "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consecteturContrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur";
export const UserProfileDesc4 = "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.";
export const KelvinELedbetter = "Kelvin E. Ledbetter";
export const Like = "Like";

export const MyProfile = "My Profile";
export const Bio = "Bio";
export const ProfileBio = "On the other hand, we denounce with righteous indignation";
export const City = "City";
export const Password = "Password";
export const ConfPassword = "Confirm Password";
export const OldPassword = "Old Password";
export const Website = "Website";
export const Save = "Save";
export const PayNow="Pay Now"
export const EditProfile = "Edit Profile";
export const Company = "Company";
export const Username = "Username";
export const CreditVolume = "Credit Volume";
export const Role = "Role";
export const UsersCountryMenu = ["--Select--", "Germany", "Canada", "Usa", "Aus"];
export const UpdateProfile = "Update Profile";
export const UsersTableTitle = "Add projects And Upload";
export const UsersTableHeader = ["Project Name", "Date", "Status", "Price", ""];
export const Edit = "Edit";
export const Update = "Update";
export const Delete = "Delete";
export const TagName = "Tag Name";
export const Tagcolor = "Tag color";
export const Finish = "Finish!";
export const Step1 = "Step 1";
export const Step2 = "Step 2";
export const Step3 = "Step 3";
export const Step4 = "Step 4";

// User profile
export const EmayWalter = "Emay Walter";
export const TotalFollowers = "325";
export const TotalFollowing = "450";
export const TotalLikes = "500";
export const Latest_Photos = "Latest Photos";
export const HumanResources = "Human Resources Department";
export const Follow = "Follow";
export const year2 = "2 year";

// calendar
export const BasicCalendars = "Basic Calendar";
export const Dragging_Event = "DRAGGING EVENT";

// chats
export const CALL = "CALL";
export const STATUS = "STATUS";
export const PROFILE = "PROFILE";
export const Profile = "Profile";
export const EricaHughes = "Erica Hughes";
export const VincentPorter = "Vincent Porter";
export const Active = "Active";
export const ChataApp_p1 = "Be yourself theres no one better. ";
export const ChataApp_p2 = "Dolore magna aliqua ";
export const Send = "Send";
export const Dropzonetitle = "Drop files here or click to upload.";
export const Dropzonedisc = "This is just a demo dropzone. Selected files are";
export const actuallyuploaded = "actually uploaded.";
export const profilemail = "Mark.jecno23@gmail.com";
export const profilnumber = "+91 365 - 658 - 1236";
export const profilfax = "Fax: 123-4560";

// email
export const EmailFilter = "Email Filter";
export const MARKJENCO = "MARK JENCO";
export const MARKJENCOEMAIL = "Markjecno@gmail.com";
export const NEWMAIL = "NEW MAIL";
export const Inbox = "Inbox";
export const AllMail = "All mail";
export const Sent = "Sent";
export const Draft = "Draft";
export const Trash = "Trash";
export const TrashList = "Trash List";

export const IMPORTANT = "IMPORTANT";
export const Starred = "Starred";
export const UNREAD = "UNREAD";
export const Spam = "Spam";
export const OUTBOX = "OUTBOX";
export const UPDATE = "UPDATE";
export const ALERT = "ALERT";
export const NOTES = "NOTES";
export const NoMailFound = "No mail found";
export const NewMessage = "New Message";
export const SendMessage = "Send Message";
export const To = "To";
export const ATTACHMENTS = "ATTACHMENTS";
export const DownloadAll = "Download All";
export const Reply = "Reply";
export const ReplyAll = "Reply All";
export const Forward = "Forward";
export const More = "More";
export const Subject = "Subject";
export const Refresh = "Refresh";
export const Markasimportant = "Mark as important";
export const Movetospam = "Move to spam";
export const MovetoTrash = "Move to Trash";
export const Lormipsa = "John Deo";
export const Lormdisc = "Inquiry about our theme pages design.";
export const Hello = "Hello";
export const DearSirGoodMorning = "Dear Sir Good Morning,";
export const Elementumvarius = "Inquiry about our theme pages design.";
export const Lorem = "Koho Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework, HTML5, CSS and JQuery.It has a huge collection of reusable UI components and integrated with latest jQuery plugins.";
export const Lorem2 = "Dressing is a way of life. My customers are successful working women. I want people to be afraid of the women I dress. Age is something only in your head or a stereotype. Age means nothing when you are passionate about something. There has to be a balance between your mental satisfaction and the financial needs of your company. I want people to be afraid of the women I dress.";
export const Emailpara = "It can be used for all type of Web applications like custom admin panel, app backend, CMS or CRM. UI components and integrated with latest jQuery plugins. Koho Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework.";

export const RecentOrders = "Recent Orders";

// file-manager
export const Hometxt = "Home";
export const API = "API";
export const All = "All";
export const Recent = "Recent";
export const Recovery = "Recovery";
export const Deleteds = "Deleteds";
export const Storage = "Storage";
export const Storageused = "25 GB of 100 GB used";
export const PricingPlan = "Pricing plan";
export const PlanSpace = "100 GB Space";
export const TrialVersion = "Trial Version";
export const FREE = "FREE";
export const Free = "Free";
export const Selected = "Selected";
export const AddNew = "Add New";
export const Upload = "Upload";
export const QuickAccess = "Quick Access";
export const RecentlyOpenedFiles = "Recently opened files";
export const Folders = "Folders";
export const EndlessAdmin = "Endless admin";
export const Files = "Files";

export const CustomBoards = "Custom Board";
export const DefaultDemo = "Default Demo";

// bookmark
export const NewBookmark = "New Bookmark";
export const AddBookmark = "Add Bookmark";
export const EditBookmark = "Edit Bookmark";
export const MyBookmark = " My bookmark";
export const WebUrl = "Web Url";
export const Title = "Title";
export const Description = "Description";
export const Group = "Group";
export const Collection = "Collection";
export const General = "General";
export const MyBookmarks = "My Bookmarks";
export const Views = "Views";
export const CreatedByMe = "Created by me";
export const Favourites = "Favourites";
export const SharedWithMe = "Shared with me";
export const Tags = "Tags";
export const Newsletter = "Newsletter";
export const Holidays = "Holidays";
export const Important = "Important";
export const Orgenization = "Organization";
export const NoBookmarksFound = "No Bookmarks Found.";
export const CreateTag = "Create Tag";

// task
export const AddTask = "Add Task";
export const NewTask = "New Task";
export const TaskTitle = "Task Title";
export const SelectTag = "Select Tag";
export const Selectdefault = "Select...";
export const TodayTasks = "Today's Tasks";
export const DelayedTasks = "Delayed Tasks";
export const UpcomingTasks = "Upcoming Tasks";
export const ThisWeekTask = "This week tasks";
export const AssignedToMe = "Assigned to me";
export const MyTasks = "My tasks";
export const ThisMonthTasks = "This month tasks";
export const NoTaskDueToday = "No task due today.";
export const NoTasksFound = "No tasks found.";
export const Createtag = "Create Tag";
export const NameError = "Name is required";
export const CodeError = "Code is required";
export const IconError = "Icon is required";
export const FirstNameError = "First name is required";
export const LastNameError = "First name is required";
export const EmailError = "Email is required";
export const CountryError = "Country is required";
export const PhoneError = "Phone is required";
export const PasswordError = "Password is required";
export const ConfirmPasswordError = "Confirm password is required";
export const UsernameError = "User name is required";
export const Choose = "Choose...";
export const CityError = "Please provide a valid city.";
export const StateError = "Please select a valid state.";
export const ZipError = "Please provide a valid zip.";
export const TitleError = "Title is required";
export const DescError = "Description is required";
export const SubTask = "Sub Task";
export const SelectCollection = "Sellect Collection";
export const SupportText = "Not interested in custom validation feedback messages or writing JavaScript to change form behaviors? All good, you can use the browser defaults. Try submitting the form below. Depending on your browser and OS, you’ll see a slightly different style of feedback.";
export const SupportText2 = "While these feedback styles cannot be styled with CSS, you can still customize the feedback text through JavaScript.";

// social app

export const Timline = "Timline";
export const About = "About";
export const AboutM = "About Me";
export const GeneralManager = "general manager";
export const Friends = "Friends";
export const Photos = "Photos";

export const MoreCommnets = "More Comments";
export const ELANA = "ELANA";
export const JasonBorne = "Jason Borne";
export const AlexendraDhadio = "Alexendra Dhadio";
export const OliviaJon = "Olivia Jon";
export const IssaBell = "Issa Bell";
export const YearAgo = "1 Year Ago";
export const MonthAgo = "1 Month Ago";
export const Days15Ago = "15 Days Ago";

export const SocialNetworks = "Social Networks";
export const ProfileIntro = "Profile Intro";
export const LatestPhotos = "Latest Photos";
export const FavouriteMusicBands = "Favourite Music Bands";
export const Dribbble = "Dribbble";
export const BuckyBarnes = "Bucky Barnes";
export const SarahLoren = "Sarah Loren";
export const ComerenDiaz = "Comeren Diaz";
export const AndewJon = "Andew Jon";
export const JohnyWaston = "Johny Waston";
export const JohnyWilliam = "Johny William";
export const AnnaMull = "Anna Mull";
export const KarleneLex = "Karlene Lex";
export const VellaChism = "Vella Chism";
export const WaiSchalk = "Wai Schalk";
export const DionCast = "Dion Cast";
export const AddFriend = "Add Friend";
export const Hobbies = "Hobbies";
export const MyPage = "My Page";
export const Likes = "Likes";
export const View = "View";
export const MutualFriends = "Mutual Friends";
export const ActivityFeed = "Activity Feed";
export const ActivityLog = "Activity Log";
export const PortfolioTitle = "Portfolio Title";
export const SocialProfiledesc = "35 New Likes This Week";
export const comment = "we are working for the dance and sing songs.this car is very awesome for the youngster.please vote this car and like our post";
export const comment2 = "The only way to do something in depth is to work hard. I have always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul.";
export const comment3 = "yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-)";
export const comment4 = "i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus";
export const SocialTime = "September, 01,2023";
export const Photo = "Photo";
export const AboutMetext = "Hi, I’m elana, I’m 30 and I work as a web Designer for the “Daydreams” Agency in Pier 56.";
export const FavouriteTvShow = "Favourite TV shows";
export const FavouriteText = "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.";
export const Markallasfinished = "Mark all as finished";
export const MarkallasIncomplete = "Mark all as Incomplete";
export const TheNewCollege = "The New College of Design";
export const EducationandEmployement = "Education and Employement";
export const PepoleYouMayKnow = "Pepole You May Know";
export const ViewedYourProfile = "Viewed Your Profile";
export const photodescription = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";

// contact
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";
export const NewContacts = " New Contacts";
export const AddContacts = " Add Contact";
export const Age = "Age";
export const Mobile = "Mobile";
export const MobileNo = "Mobile No";
export const Personal = "Personal";
export const AddCategory = "Add Category";
export const FollowUp = "Follow up";
export const Ideas = "Ideas";
export const History = "History";
export const NoDataFound = "No Data Found";
export const Gender = "Gender";
export const Male = "Male";
export const Female = "Female";
export const PrintViews = "Print preview";
export const Contacts10 = "10 Contacts";
export const Contacts = "Contacts";
export const Contactiscreatedviamail = "Contact is created via mail";
export const ContactTime = "Sep 10, 2022 4:00";
export const ContactDesc = "Contact has not been modified yet.";
export const NotFoundContact = "Sorry, Not Found Any Contact";
export const HavePassword = "Have Password";

// todo
export const ToDo = "To-Do";
export const ToDoList = "To Do List";
export const AddNewTask = "Add new task";
export const Close = "Close";
export const AllTask = "All Task";

// UI-KITS
export const DefaultColor = "Default Color";
export const Color = "Color";
export const Primary = "Primary";
export const secondary = "Secondary";
export const Success = "Success";
export const Info = "Info";
export const Warning = "Warning";
export const Information = "Information";
export const Danger = "Danger";
export const Pink = "Pink";
export const Grey = "Grey";
export const Dark = "Dark";
export const Light = "Light";

export const Headings = "Headings";
export const SubHeading = "Sub Heading";
export const Heading1 = "Heading 1";
export const Heading2 = "Heading 2";
export const Heading3 = "Heading 3";
export const Heading4 = "Heading 4";
export const Heading5 = "Heading 5";
export const Heading6 = "Heading 6";
export const VeryThin100 = "Very Thin (100)";
export const Thin300 = "Thin (300)";
export const Normal400 = "Normal (400)";
export const LightNormal600 = "light Normal (600)";
export const Bold700 = "Bold (700)";
export const ExtraBold900 = "Extra Bold (900)";
export const DisplayHeadings = "Display headings";
export const displayHeading = "display heading";
export const DisplayHeadingsText = "Traditional heading elements are designed to work best in the meat of your page content. When you need a heading to stand out, consider using a";
export const DisplayHeadingsText2 = "—a larger, slightly more opinionated heading style.";
export const TextColor = "Text Color";
export const ListingTypography = "Listing Typography";
export const UnorderList = "Unorder list";
export const OrderList = "Order list";
export const FontawesomeList = "Fontawesome list";
export const ICOIconList = "ICO Icon list";
export const ThemfyList = "Themify list";
export const Blockquotes = "Blockquotes";
export const SourceTitle = "Source Title";

export const Display = "Display";
export const Lead = "Lead";
export const Leadd = ".lead.";
export const Leadtext = "Make a paragraph stand out by adding";
export const LeadPara = "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.";
export const Inlinetextelements = "Inline text elements";
export const Inlinetext = "Styling for common inline HTML5 elements.";
export const Inlinetext2 = "You can use the mark tag to";

export const highlight = " highlight";
export const textd = " text.";
export const deltext = "This line of text is meant to be treated as deleted text.";
export const stext = "This line of text is meant to be treated as no longer accurate.";
export const instext = "This line of text is meant to be treated as an addition to the document.";
export const utext = "This line of text will render as underlined";
export const smalltext = "This line of text is meant to be treated as fine print.";
export const strongtext = "This line rendered as bold text.";
export const emtext = "This line rendered as italicized text.";

export const spclass = " class";
export const txt_primary = "txt-primary";
export const txt_secondary = "txt-secondary";
export const txt_success = "txt-success";
export const txt_info = "txt-info";
export const txt_warning = "txt-warning";
export const txt_danger = "txt-danger";
export const txt_dark = "txt-dark";
export const Thisis = "This is ";
export const colortext = " text You can archive this adding";
export const textcolorPara = "You can Give text color by using txt-* class";

export const Listrtext = "Lorem ipsum dolor sit amet";
export const Adda = "Add a";
export const ChangePassword = "Change Password";
export const BlockcardText = "footer class='blockquote-footer'";
export const BlockcardText1 = "for identifying the source. Wrap the name of the source work in";
export const cite = "cite";
export const Namingasource = "Naming a source";
export const BlockcardText2 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.";
export const Someonefamousin = "Someone famous in ";
export const AlignmentCenter = "Alignment Center";

export const Sizing = "Sizing";
export const sizetable = "Sizing Table";
export const StatusIndicator = "Status Indicator";
export const Initials = "Initials";
export const Shape = "Shape";
export const Ratio = "Ratio";
export const Groups = "Groups";

export const Padding = "Padding";
export const Margins = "Margins";
export const PaddingLeft = "Padding Left";
export const PaddingRight = "Padding Right";
export const PaddingTop = "Padding Top";
export const PaddingBottom = "Padding Bottom";
export const MarginLeft = "Margin Left";
export const MarginRight = "Margin Right";
export const MarginTop = "Margin Top";
export const MarginBottom = "Margin Bottom";
export const VerticalAlign = "Vertical Align";
export const ImageSizes = "Image Sizes";
export const BadgeColor = "Badge Color";
export const BackgroundColor = "Background Color";
export const ButtonColor = "Button Color";
export const BorderRadius = "Border Radius";
export const FontWeight = "Font Weight";
export const FontStyle = "Font Style";
export const Float = "Float";
export const Overflow = "Overflow";
export const FontSize = "Font Size";
export const AllBordersColor = "All Borders Color";
export const BorderWidth = "Border Width";
export const Position = "Position";
export const ButtonOutline = "Button Outline";
export const Typography = "Typography";
export const through = "through";
export const areavailable = "are available";
export const AllHTMLheadings = "All HTML headings";

export const ThisisaHeading = "This is a Heading";
export const FadeHeadingtext = "Use the included utility classes to recreate the small secondary heading text.";
export const Fancyheading = "Fancy display heading";
export const Fancyheadingtext = "With faded secondary text";

export const GridOptions = "Grid Options";
export const GridOptionstext = "Bootstrap grid allows building an equal height flexbile blocks easily";
export const ExtraSmall = "Extra small";
export const Large = "Large";
export const ExtraLarge = "Extra large";
export const XXLarge = "Extra extra large";
export const GridBehavior = "Grid behavior";
export const GutterWidth = "Gutter width";
export const Nestable = "Nestable";
export const ColumnOrdering = "Column ordering";
export const GridColumn = "Grid Column";
export const NestingColumn = "Nesting Column";

export const Offsets = "Offsets";
export const Offsetstext = "Move columns to the right using";
export const Offsetcode = ".offset-md-*";
export const Offsetstext1 = "classes. These classes increase the left margin of a column by";
export const Offsetstext2 = "columns. For example,";
export const Offsetcode1 = ".offset-md-4";
export const moves = "moves";
export const Offsetcode2 = ".col-md-4";
export const Offsetstext3 = "over four columns.";

export const Order = "Order";
export const Use = "Use";
export const tablestriped = ".table-striped";
export const tablestripedspan = "to add zebra-striping to any table row within the";
export const tablestripedspan1 = "This styling doesn't work in IE8 and below as :nth-child CSS selector isn't supported.";
export const dorder = ".order-";
export const Ordertext = "classes for controlling the";
export const Ordertext1 = "visual order";
export const Ordertext2 = "of your content. These classes are responsive, so you can set the";
export const Ordertext3 = "by breakpoint (e.g.,";
export const Ordercode = ".order-1.order-md-2";
export const Ordertext4 = "). Includes support for";
export const Ordertext5 = "across all five grid tiers.";
export const Firstunordered = "First, but unordered";
export const Secondlast = "Second, but last";
export const Thirdfirst = "Third, but first";
export const Firstlast = "First, but last";
export const Secondunordered = "Second, but unordered";

export const GridPara = "While Bootstrap uses";
export const em = "em";
export const or = "or";
export const rem = "rem";
export const GridPara2 = "for defining most sizes";
export const px = "px";
export const GridPara3 = "are used for grid breakpoints and container widths. This is because the viewport width is in pixels and does not change with the";
export const Horizontaltimes = "Horizontal at all times";
export const HorizontalPara = "Collapsed to start, horizontal above breakpoints";
export const Noneauto = "None (auto)";
export const Maxcontainerwidth = "Max container width";
export const Classprefix = "Class prefix";
export const Yes = "Yes";
export const No = "No";
export const GutterWidthtext = "1.5rem (.75rem on left and right)";

export const GridColtext = "Using a single set of";
export const colmd = "col-md-";
export const GridColtext2 = "grid classes, you can create a basic grid system that starts out stacked on mobile devices and tablet devices (the extra small to small range) before becoming horizontal on desktop (medium) devices. Place grid columns within any";
export const drow = ".row";

export const Settingonecolumnwidth = "Setting one column width";
export const Settingtext = "Auto-layout for flexbox grid columns also means you can set the width of one column and have the sibling columns automatically resize around it. You may use predefined grid classes (as shown below), grid mixins, or inline widths. Note that the other columns will resize no matter the width of the center column.";
export const VerticalAlignment = "Vertical alignment";
export const Textpara = "Use flexbox alignment utilities to vertically and horizontally align columns.";
export const Oneofthreecolumns = "One of three columns";
export const HorizontalAlignment = "Horizontal alignment";

export const ContextualVariations = "Contextual variations";
export const TagsWithNumber = "Tags with number";
export const PillsWithNumber = "Pills with number";
export const TagsWithIcon = "Tags With icon";
export const PillsWithIcon = "Pills with Icon";
export const BadgesExample = "Badges Example";
export const heading = "heading";

export const BasicProgressBars = "Basic Progress Bars";
export const BasicProgressBarsPara = "Progress components are built with two HTML elements, some CSS to set the width, and a few attributes.";
export const SmallProgressBars = "Small Progress Bars";
export const SmallProgresscode = ".sm-progress-bar";
export const Progresstext = "class to change progress size to small:";
export const LargeProgressBars = "Large Progress Bars";
export const LargeProgresscode = ".lg-progress-bar";
export const CustomHeightProgressBars = "Custom Height Progress Bars";
export const CustomHeighttext = "Set a height value on the";
export const CustomHeightcode = ".progress-bar";
export const CustomHeighttext2 = ", so if you change that value the outer";
export const CustomHeightcode2 = ".progress";
export const CustomHeighttext3 = "will automatically resize accordingly.";
export const ProgressBarsStates = "Progress Bars states";
export const ProgressBarstext = "Use state utility classes to change the appearance of individual progress bars.";
export const MultipleBars = "Multiple bars";
export const MultipleBarsText = "Include multiple progress bars in a progress component if you need.";
export const MultipleBarsText2 = ".progress-bar-striped";
export const toany = "to any";
export const MultipleBarsText3 = "to apply a stripe via CSS gradient over the progress bar’s background color.";
export const ProgressBarsStriped = "Progress Bars Striped";
export const ProgressBarsAnimated = "Progress Bars animated";
export const ProgressAnimatedtext = "The striped gradient can also be animated. Add";
export const ProgressAnimatedcode = ".progress-bar-animated";
export const ProgressAnimatedtext2 = "to animate the stripes right to left via CSS3 animations.";

export const StaticExample = "Static Example";
export const BasicModal = "Basic Modal";
export const Simple = "Simple";
export const ModalTitle = "Modal title";
export const SaveChanges = "Save changes";
export const ScrollingLongContent = "Scrolling long content";
export const VerticallyCentered = "Vertically centered";
export const TooltipsAndPopovers = "Tooltips and popovers";
export const UsingTheGrid = "Using the grid";
export const VaryingModalContent = "Varying modal content";
export const SizesModal = "Sizes modal";
export const LargeModal = "Large modal";
export const SmallModal = "Small modal";
export const Modalcontent =
  "Knowledge can be defined as awareness of facts or as practical skills, and may also refer to familiarity with objects or situations. Knowledge of facts, also called propositional knowledge, is often defined as true belief that is distinct from opinion or guesswork by virtue of justification. While there is wide agreement among philosophers that it is a form of true belief, many controversies in philosophy focus on justification: whether it is needed at all, how to understand it, and whether something else besides it is needed.";
export const Pilltabcontent = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages";
export const Modalsmallpara = "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s";
export const scrollmodaltext = "Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.";
export const scrollmodaltext1 = "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.";
export const scrollmodaltext2 = "Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.";
export const Popovermodal = "Popover in a modal";
export const This = "This";
export const buttontext = "triggers a popover on click.";
export const Thisisbutton = "This is button";
export const Tooltipsmodal = "Tooltips in a modal";
export const thatlink = "that link";
export const thatlinktext = "have tooltips on hover.";
export const ThisisLink = "This is Link";

export const Updateavailable = "Update available";
export const PlayingNow = "Playing Now";
export const DataUses = "1.2 GB Used";
export const Alert = "Alert";

export const ThemeColorAlerts = "Theme Color Alerts";
export const ThemeAlerttext = "Theme color Archive just adding class";
export const ddark = ".dark";
export const Linkthemecolor = "Link color in theme-color";
export const Usethe = "Use the";
export const alertlink = ".alert-link";
export const Linkcolortext = "utility class to quickly provide matching colored links within any alert";
export const ExamleLink = "an example link.";
export const ClickIt = "Click It";

export const AlertWithIcon = "Alert With Icon";
export const AlertText = "Just add Any icon before text";
export const Alertpara = "You can check in on some of those fields below.";
export const LightAlerts = "Light Alerts";
export const LightAlertText = "Alerts are available for any length of text, as well as an optional dismiss button.";
export const LinkColor = "Link color";
export const Dismissing = "Dismissing";
export const Dismissingtext = "To animate alerts when dismissing them, be sure to add the .fade and .show classes.";
export const Holy = "Holy ! ";
export const OutlineAlerts = "Outline Alerts";
export const OutlineAlertstext = "Outline Archive just adding class";
export const OutlineDarkAlerts = "Outline Dark Alerts";
export const doutline = ".outline";
export const doutline2 = ".outline-2x";
export const AlertWithIconOutline = "Alert With Icon outline";
export const AlertWithIconInverse = "Alert With Icon inverse";
export const AlertWithIconpara = "Your time Over after ";
export const AdditionalContent = "Additional content";
export const Additionaltext = "Alerts can also contain additional HTML elements like headings, paragraphs and dividers.";
export const Welldone = "Well done!";
export const Aditionalpara = "Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.";
export const Aditionalpara2 = "Whenever you need to, be sure to use margin utilities to keep things nice and tidy.";
export const miniute = "miniute";
export const TextAsAction = "Text as action";

export const BasicExamples = "Basic Examples";
export const BasicExamplestext = "lorem ipsum dolor sit amet, consectetur adipisicing elit";
export const Direction = "Direction";
export const HTMLContent = "HTML Content";
export const OffsetToTooltip = "Offset to Tooltip";

export const WithTitleAlert = "With Title alert";
export const SuccessAlert = "Success alert";
export const InfoAlert = "Info alert";
export const WarningAlert = "Info alert";
export const Basic = "Basic";

export const BasicTooltip = "Basic Tooltip";
export const Tooltipontop = "Tooltip on top";
export const Tooltiptitle = "Tooltip title";
export const Clickme = "Click me";
export const HoverMe = "Hover Me";
export const PopoverTitle = "Popover title";
export const Popoverontop = "Popover on top";
export const Popoverbodytext = "And heres some amazing content. Its very engaging. Right?";
export const Popoverbodytext2 = "Vivamus sagittis lacus vel augue laoreet rutrum faucibus.";
export const HTMLElements = "HTML elements";
export const Clicktotogglepopover = "Click to toggle popover";

export const LoaderStyle = "Loader Style";

export const BasicDropdown = "Basic Dropdown";
export const DropdownButton = "Dropdown Button";
export const Dropdown = "Dropdown";
export const Action = "Action ";
export const AnotherAction = "Another action";
export const AnotherLink = "Another Link";
export const SomethingElseHere = "Something else here";
export const BasicColorDropdown = "Basic Color Dropdown";
export const DropdownSplitButton = "Dropdown Split Button";
export const RoundedDropdown = "Rounded Dropdown";
export const DropdownWithDivider = "Dropdown With Divider";
export const DropdownWithHeader = "Dropdown With Header";
export const DropdownWithDisable = "Dropdown With Disable";
export const DropdownWithDropUp = "Dropdown With DropUp";
export const Normal = "Normal";
export const Disabled = "Disabled";
export const not = "not";
export const DropdownHeader = "Dropdown Header";
export const dropup = ".drop-up";
export const SeparatedLink = "Separated Link";
export const Button = "Button";
export const ButtonDropdown = "Button Dropdown";

export const BasicAccordion = "Basic Accordion";
export const BasicAccordiontext = "component, you can extend the default collapse behavior to create an accordion.";
export const BasicAccordionpara = "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.";
export const Usingthe = "Using the";
export const card = "card";
export const CollapsibleGroupItem = "Collapsible Group Item #";
export const Accordialtext =
  "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.";
export const AllCloseAccordion = "All Close Accordion";
export const ColorAccordion = "Color Accordion";
export const bgstar = ".bg-*";
export const Colorparatext = "class to add background color with card-header.";
export const ColorPara =
  "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.";
export const AccordionWithIconOnTitle = "Accordion With Icon on Title";
export const AccordionOpenCloseIcon = "Accordion open close icon";
export const Accordioncode = "<i></i>";
export const Accordionspan = "tag Along with icon class before title text.";

export const BasicTabs = "Basic Tabs";
export const dropdown = "Dropdown";
export const TabsBottomLeftAlign = "Tabs bottom left Align";
export const TabsWithIcon = "Tabs With Icon";
export const TabsRightAlign = "Tabs Right Align";
export const TabsVertical = "Tabs Vertical";
export const PillTabs = "Pill Tabs";
export const PillTabsWithIcon = "Pill Tabs With Icon";
export const PillDarkColor = "Pill Dark color";
export const Navstar = ".nav-*";
export const nav_pill = "nav-pill";
export const nav_primary = ".nav-primary";
export const nav_secondary = ".nav-secondary";
export const nav_success = ".nav-success";
export const nav_info = ".nav-info";
export const nav_warning = ".nav-warning";
export const nav_danger = ".nav-danger";
export const border_tab = ".border-tab";
export const Pillspan1 = "class with nav class";
export const Pillspan2 = "class from pill style Tab";
export const remove = "remove";
export const PrimaryColor = "Primary Color";
export const SecondaryColor = "Secondary Color";
export const SuccessColor = "Success Color";
export const InfoColor = "Info Color";
export const WarningColor = "Warning Color";
export const DangerColor = "Danger Color";

export const SimpleMaterialTab = "Simple Material style tab";
export const MaterialBottomTab = "Material style bottom tab";
export const MaterialLeftTab = "Material style left tab";
export const MaterialRightTab = "Material style Right tab";
export const MaterialColorTab = "Material color tab";

export const DefaultNav = "Default Nav";
export const Base = "Base";
export const Forms = "Forms";
export const Tables = "Tables";
export const table = "table";
export const tabletext = "to any table.";
export const bottomcolor = "and .border-bottom-* class for Border bottom color";
export const Useclass = "Use a class";
export const dropdowndivider = ".dropdown-divider";
export const dropdownHeader = ".dropdown-header";
export const dropdownDisable = ".dropdown-disabled";
export const insidetable = "inside table element.";
export const tableinverse = "table-inverse";
export const DropdownExample = "Dropdown example";
export const inverstablecode = ".bg-info, .bg-success, .bg-warning and .bg-danger classes.";
export const inverstabletext = "with light text on dark backgrounds inside table element.";
export const inverstabletext2 = "To set the light background color use .bg-[color] class where [color] is the value of your selected color from stack color palette. So for teal color background class will be .bg-teal";
export const FilmTitle = "Film Title";
export const Released = "Released";
export const Studio = "Studio";
export const Budget = "Budget";
export const DomesticGross = "Domestic Gross";
export const classname = "ClassName";
export const Trainer = "Trainer";
export const Spots = "Spots";

export const ItemBullets = "Item Bullets";
export const SectionAndSeparator = "Section and Separator";
export const Layouts = "Layout";
export const Sidebars = "Sidebar";
export const Checknow = "Check now";
export const Sidebarmenutext = "Experiance with more Features";
export const Charts = "Charts";
export const Maps = "Maps";
export const Audios = "Audios";
export const Editors = "Editors";
export const TreeView = "TreeView";
export const Rating = "Rating";
export const Scrollable = "Scrollable";
export const Advance = "Advance";
export const Timeline = "Timeline";
export const Cards = "Cards";
export const PageLayout = "Page Layout";
export const Footers = "Footers";
export const LogOut = "Log Out";
export const ActiveAndDisabledLinks = "Active and Disabled Links";
export const InlineNav = "Inline Nav";
export const SubNav = "Sub Nav";
export const StaticSubNav = "Static Sub Nav";
export const ToggleSubNav = "Toggle Sub Nav";
export const Panding = "Panding";
export const Replied = "Replied";
export const Titleofsection = "Start With This";
export const Secondsection = "Video Tutorial";
export const Thirdsection = "Layout Drafts";
export const Fourthsection = "Audio Tutorial";
export const Fifthsection = "Team Work";
export const FinalSection = "Final Testing";
export const Finaltext = "Explain any new understanding or fresh insights about the problem. This is the content of the Testing.";
export const Finaltext1 = "Your browser does not support the audio element.";
export const Finaltext2 = "This is the content of the last section";
export const FooterText = "Powered by Billerq";

export const Examples = "Examples";
export const Shadowpara = "While shadows on components are disabled by default in Bootstrap and can be enabled via";
export const Shadowcode = "$enable-shadows";
export const Shadowpara1 = "you can also quickly add or remove a shadow with our";
export const box_shadow = "box-shadow";
export const Shadowpara2 = "utility classes. Includes support for";
export const shadow_none = ".shadow-none";
export const Shadowpara3 = "and three default sizes (which have associated variables to match).";
export const LargerShadow = "Larger shadow";
export const RegularShadow = "Regular shadow";
export const SmallShadow = "Small shadow";
export const NoShadow = "No shadow";
export const MiamiFL = "Miami, FL";
export const Miamipara = "Creative Direction, User Experience, Visual Design, Project Management, Team Leading";
export const LosAngelesCA = "Los Angeles, CA";
export const SanFranciscoCA = "San Francisco, CA";
export const OnlineCourse = "Online Course";
export const Certification = "Certification";

export const DefaultList = "Default list";
export const Defaultitem1 = "Cras justo odio";
export const Defaultitem2 = "Dapibus ac facilisis in";
export const Defaultitem3 = "Morbi leo risus";
export const Defaultitem4 = "Porta ac consectetur ac";
export const Defaultitem5 = "Vestibulum at eros";
export const Primarytext = "This is a primary list group item";
export const Secondarytext = "This is a secondary list group item";
export const Successtext = "This is a success list group item";
export const Dangertext = "This is a danger list group item";
export const Warningtext = "This is a warning list group item";
export const Infotext = "This is a Info list group item";
export const Ligthtext = "This is a Light list group item";
export const Darktext = "This is a dark list group item";
export const ListGrouphead = "List group item heading";
export const Daysago = "3 days ago";
export const CustomcontentText = "Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.";
export const CustomcontentText2 = "Donec id elit non mi porta.";

export const LinksAndButtons = "Links and buttons";
export const FlushStyle = "Flush Style";
export const ContextualClasses = "Contextual classes";
export const WithBadges = "With badges";
export const CustomContent = "Custom content";
export const JavaScriptBehavior = "JavaScript behavior";
export const WithIcon = "With Icon";
export const WithImages = "With Images";
export const WithImageRounded = "With Image Rounded";

// bonus ui
export const VerticalScrollbar = "Vertical Scrollbar";
export const SmoothScrollbar = "Smooth Scrollbar";
export const NoScrollbar = "No Scrollbar";

export const CustomDirections = "Custom  Directions";
export const CustomAutoclose = "Custom Autoclose";

export const StarRating = "Star Rating";
export const YouRated = "You Rated";
export const HeartRating = "Heart Rating";
export const ThumbsUpDownRating = "Thumbs Up/Down Rating";
export const PillRating = "Pill Rating";

export const SingleFileUpload = "Single File Upload";
export const MultiImageUpload = "Multi only Image Upload";
export const MultipleImageVideoAudioUpload = "Multiple Image Video Audio Upload";
export const LimitationFileUpload = "Limitation File Upload";
export const CustomFileUpload = "Custom File Upload";

export const AdvancedState = "Advanced State";
export const AlertState = "Alert State";

export const Carousel = "Carousel";
export const UncontrolledCarousel = "Uncontrolled Carousel";
export const CarouselClassname = "Carousel Using a Tag And Classname";

export const SuccessNotification = "Success Notification";
export const InfoNotification = "Info Notification";
export const WarningNotification = "Warning Notification";
export const DangerNotification = "Danger Notification";
export const TopCenter = "Top Center";
export const BottomCenter = "Bottom Center";
export const BottomLeft = "Bottom Left";
export const RightBottom = "Right Bottom";
export const AutoCloseIn15000Sec = "AutoClose in 15000 Sec";
export const AutoCloseIn5000Sec = "AutoClose in 5000 Sec";
export const AutoCloseIn1000Sec = "AutoClose in 1000 Sec";
export const AutoCloseIn500Sec = "AutoClose in 500 Sec";

export const ColoredBreadcrumb = "Colored breadcrumb";
export const ColoredRibbons = "Colored Ribbons";
export const useclass = "use class";
export const Colorcode = ".breadcrumb-colored .bg-primary";
export const ribboncode = ".ribbons-colored .bg-primary";
export const ribbon = "Ribbon";
export const ribbontext = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.";

export const Pagi_Nations = "Pagination";
export const PaginationWithIcons = "Pagination with icons";
export const PaginationAlignment = "Pagination alignment";
export const PaginationActiveDisabled = "Pagination with active and disabled";
export const PaginationColor = "Pagination Color";
export const PaginationSizing = "Pagination sizing";
export const Previous = "Previous";
export const Next = "Next";

export const Default_Step = "Default Step";
export const Step_With_Icon = "Step with icon";
export const Step_States = "Step States";
export const Step_Sizing = "Step Sizing";
export const Vertical_Step = "Vertical Step";
export const Default_Pearls_Steps = "Default Pearls Steps";
export const Pearls_Steps_Icon = "Pearls Steps with icon";
export const Pearls_Step_Sizing = "Pearls Step Sizing";
export const Pearls_Step_States = "Pearls Step States";

export const DefaultBootstrapBreadcrumb = "Default bootstrap breadcrumb";
export const Defaultcode = ".breadcrumb to ol";
export const Home = "Home";
export const NavBreadcrumb = "Nav breadcrumb";
export const NavBreadcode = ".breadcrumb to nav";
export const NavBreadtext = "similar to navigation";
export const Library = "Library";
export const Data = "Data";
export const Bootstrap = "Bootstrap";

export const BasicSlider = "Basic Slider";
export const Default = "Default";
export const NegativeValues = "Negative Values";
export const FormatedLabel = "Formated Label";
export const DraggableRange = "Draggable Range";

export const ImageCropper = "Image Cropper";
export const StickyNote = "Sticky Note";
export const AddNewNote = "Add New Note";

export const clickAndDrag = "Click And Drag";
export const smallSizescroll = "Small Size Scroll";
export const bothSidescroll = "Both Side Scroll";
export const horizontalscroll = "Horizontal Scroll";
export const SpillDragNDrop = "Spill Drag N Drop";
export const CopyDragNDrop = "Copy Drag N Drop";

export const MultipleImageUpload = "Multiple Image Upload";
export const SelectSingleImageUpload = "Select Single Image Upload";

export const BasicCard = "Basic Card";
export const FlatCard = "Flat Card";
export const WithoutShadowCard = "Without shadow Card";
export const IconInHeading = "Icon in Heading";
export const CardSubTitle = "Card sub Title";
export const CardWithFooter = "Card With Footer";
export const Card_Footer = "Card Footer";
export const PrimaryColorCard = "Primary Color Card";
export const SecondaryColorCard = "Secondary Color Card";
export const SuccessColorCard = "Success Color Card";
export const PrimaryColorHeader = "Primary Color Header";
export const PrimaryColorBody = "Primary Color Body";
export const PrimaryColorFooter = "Primary Color Footer";

export const BorderLeft = "Border left";
export const BorderRight = "Border right";
export const BorderTop = "Border top";
export const BorderBottom = "Border bottom";
export const BorderColorState = "Border color state";
export const AbsoluteStyle = "Absolute Style";
export const ColorState = "Color state";

export const SimpleTab = "Simple Tab";
export const ColorTab = "Color Tab";
export const ColorOption = "Color Option";
export const MaterialTabWithColor = "Material Tab With Color";
export const MaterialTab = "Material Tab";
export const MaterialTabWithIcon = "Material Tab With Icon ";

export const DragBothTitleCard = "Drag Both Title and card";
export const DragOnlyCard = "Drag only card";
export const DragOnlyContent = " Drag only Content";

export const TimelinePrimaryColor = "Timeline Primary color";
export const NewSale = "New Sale";
export const NewReport = "New Report";
export const NewVisits = "New Visits";
export const TimelineSecondaryColor = "Timeline secondary color";
export const TimelineSuccessColor = "Timeline Success color";
export const TimelineInfoColor = "Timeline Info color";
export const TimelineWarningColor = "Timeline Warning color";
export const TimelineDangerColor = "Timeline Danger color";

export const FlagIcons = "Flag Icons";
export const Currency = "Currency Icons";
export const Currencys="Currency"
export const Icons = "Icons";
export const WebApp = "Web App Icons";
export const Spinner = "Spinner Icons";
export const FormControl = "Form Control Icons";
export const TextEditor = "Text Editor Icons";
export const Directional = "Directional";
export const Markup = "Markup";

export const VideoPlayer = "Video Player Icons";
export const BrandPlayer = "Brand Player Icons";
export const MedicalPlayer = "Medical Player Icons";

export const Abstract = "Abstract";
export const Animal = "Animal";
export const Construction = "Construction";
export const Device = "Device";
export const Education = "Education";
export const Emotion = "Emotion";
export const FileType = "File Type";
export const Food = "Food";
export const KidsToys = "Kids & Toys";
export const Law = "Law";
export const Mathematical = "Mathematical";
export const Medical = "Medical";
export const MobileUI = "Mobile UI";
export const Multimedia = "Multimedia";
export const Payment = "Payment";
export const Person = "Person";
export const Search = "Search";
export const Social = "Social";
export const Sport = "Sport";
export const Transport = "Transport";
export const Travel = "Travel";
export const Weather = "Weather";
export const WebApplication = "Web Application";

export const ArrowsDirection = "Arrows & Direction Icons";
export const Control = "Control Icons";

export const Feathericon = "Feather Icons";
export const WhetherIconsWithAnimations = "Whether Icons With Animations";

export const SimpleLineIcons = "Simple-Line Icons";
export const TypiconsIcons = "typicons Icons";
export const Pe7Icons = "pe7 Icons";
export const IonicIcons = "ionic Icons";

export const DefaultButtons = "Default Buttons";
export const DefaultButton = "Default Button";
export const Flatbutton = "Flat button";
export const Edgebutton = "Edge button";
export const Raisedbutton = "Raised button";
export const buttonoutline = "button outline";
export const gradien = "Gradient";
export const ButtonSize = "Button Size";
export const BootstrapStateButtons = "Bootstrap state buttons";
export const PrimaryButton = "Primary Button";
export const Link1 = "Link 1";
export const SecondaryButton = "Secondary Button";
export const SuccessButton = "Success Button";
export const InfoButton = "Info Button";
export const WarningButton = "Warning Button";
export const DangerButton = "Danger Button";
export const LightButton = "Light Button";
export const LargeButtons = "Large Buttons";
export const SmallButtons = "Small Buttons";
export const ExtraSmallButtons = "Extra Small Buttons";
export const ActiveButtons = "Active Buttons";
export const DisabledButtons = "Disabled Buttons";
export const CustomStateButtons = "Custom state Buttons";
export const OutlineButtons = "Outline Buttons";
export const BoldBorderOutlineButtons = "Bold Border outline Buttons";
export const OutlineLargeButtons = "Outline Large Buttons";
export const OutlineSmallButtons = "Outline Small Buttons";
export const OutlineExtraSmallButtons = "Outline Extra Small Buttons";
export const DisabledOutlineButtons = "Disabled Outline Buttons";
export const GradienButtons = "Gradient Buttons";

export const BasicButtonGroup = "Basic button group";
export const EdgesButtonGroup = "Edges button group";
export const FlatButtonGroup = "Flat button group";
export const LargeButtonGroup = "large Button group";
export const LargeEdgesButtonGroup = "large Edges Button group";
export const OutlineCustomButtonGroup = "Outline Custom button group";
export const OutlineButtonGroup = "Outline button group";
export const OutlineEdgesButton = "Outline Edges button";
export const OutlineFlatButton = "Outline flat button";
export const RadioButtonGroup = "Radio button group";
export const CheckBoxButtonGroup = "Check Box button group";
export const Nesting = "Nesting";
export const Vertical = "Vertical";
export const Left = "Left";
export const Middle = "Middle";
export const Right = "Right";

export const BasicAreaChart = "Basic Area Chart";
export const AreaSpalineChart = "Area Spaline Chart";
export const BarChart = "Bar chart";
export const ColumnChart = "Column Chart";
export const BubbleChart = "3d Bubble Chart";
export const SteplineChart = "Stepline Chart";
export const PieChart = "Pie Chart";
export const DonutChart = "Donut Chart";
export const MixedChart = "Mixed Chart";
export const CandlestickChart = "Candlestick Chart";
export const RadarChart = "Radar Chart";
export const RadialBarChart = "Radial Bar Chart";

export const RotatingPieChart = "Rotating A Pie Chart";
export const SliceVisibilityThreshold = "Slice Visibility Threshold";
export const StackingAreaChart = "Stacking Area Chart";
export const AreaChart = "Area Chart";
export const BasicBarChart = "Basic bar Chart";
export const MaterialDesign = "Material Design";
export const GanttChart = "Gantt Chart";
export const ComboChart = "ComboChart";
export const BarChart2 = "bar-chart2";
export const WordTree = "Word tree";
export const LineChart = "Line Chart";

export const LineChart2 = "Line Chart-2 Chart";
export const PolarChart = "Polar Chart";
export const DoughnutChart = "Doughnut Chart";

export const AdvancedSMILAnimations = "Advanced SMIL Animations";
export const SVGPathAnimation = "SVG Path animation";
export const AnimatingDonutWithSvg = "Animating a Donut with Svg.animate";
export const BipolarLinechart = "Bi-polar Line chart with area only";
export const LineChartWithArea = "Line chart with area";
export const BipolarBarChart = "Bi-polar bar chart";
export const StackedBarChart = "Stacked bar chart";
export const HorizontalBarChart = "Horizontal bar chart";
export const ExtremeResponsiveConfiguration = "Extreme responsive configuration";
export const SimpleLineChart = "Simple line chart";
export const HolesInData = "Holes in data";
export const FilledHolesInData = "Filled holes in data";

export const AngleOffset = "Angle Offset";
export const DisableDisplayInput = "Disable Display Input";
export const CursorMode = "Cursor Mode";
export const DisplayPreviousValue = "Display Previous Value";
export const AngleOffsetArc = "Angle Offset & Arc";

// forms
export const AddIndustry = "Add Industry";
export const EditIndustry = "Edit Industry";
export const BrowserDefaults = "Browser defaults";
export const SupportedElements = "Supported elements";
export const Tooltips = "Tooltips";
export const Zip = "Zip";
export const State = "State";
export const SubmitForm = "Submit Form";
export const CustomstyleText = "For custom Bootstrap form validation messages, you’ll need to add the";
export const CustomstyleText2 = "boolean attribute to your";
export const CustomstyleText3 = ". This disables the browser default feedback tooltips, but still provides access to the form validation APIs in JavaScript. Try to submit the form below; our JavaScript will intercept the submit button and relay feedback to you.";
export const CustomstyleText4 = "When attempting to submit, you’ll see the";
export const CustomstyleText5 = "styles applied to your form controls.";
export const novalidate = "novalidate";
export const form = "form";
export const invalid = ":invalid";
export const valid = ":valid";
export const and = "and";
export const CheckboxText = "You must agree before submitting.";
export const TermsText = "Agree to terms and conditions";
export const ZipText = "Please provide a valid zip.";
export const Checkthebox = "Check this checkbox";
export const InvalidFeedback = "Example invalid feedback text";
export const InvalidcustomFiles = "Example invalid custom file feedback";
export const InvalidSelect = "Example invalid custom select feedback";
export const TextAreaerror = "Please enter a message in the textarea.";
export const ToggleRadioerror = "Or toggle this other custom radio";
export const ToggleRadio = "Toggle this custom radio";

export const BasicFormControl = "Basic form control";
export const ExampleSelect = "Example select";
export const ExampleMultipleSelect = "Example multiple select";
export const ExampleTextarea = "Example textarea";
export const BasicHTMLInputControl = "Basic HTML input control";
export const SimpleInput = "Simple Input";
export const Placeholder = "Placeholder";
export const Number = "Number";
export const Telephone = "Telephone";
export const URL = "URL";
export const DateAndTime = "Date and time";
export const ColorPicker = "Color picker";
export const MaximumLength = "Maximum Length";
export const StaticText = "Static Text";
export const EdgesInputStyle = "Edges input style";
export const FlatInputStyle = "Flat input style";
export const RaiseInputStyle = "Raise input style";
export const SolidInputStyle = "Solid input style";
export const InputSizing = "Input sizing";
export const SmallSelect = "Small select";
export const LargeSelect = "Large select";
export const DefaultSelect = "Default select";
export const DefaultInput = "Default input";
export const DateTimeText = "The Date Range Picker can also be used to select times. Hour, minute and (optional) second dropdowns are added below the calendars. An option exists to set the increment count of the minutes dropdown to e.g. offer only 15-minute or 30-minute increments.";
export const DateTimeText2 = "No Icon (input field only)";
export const EnabledDisabledDates = "Enabled/Disabled Dates";
export const ViewMode = "View Mode";
export const DisabledDaysoftheWeek = "Disabled Days of the Week";

export const CustomControls = "Custom controls";
export const UploadFile = "Upload File";
export const CustomSelect = "Custom select";
export const LargeInput = "Large Input";
export const SmallInput = "Small Input";
export const Textarea = "Textarea";
export const Select2 = "Select-2";
export const OutlineColorVariant = "Outline Color Variant";
export const FullColoredVariant = "Full Colored Variant";

export const DefaultPlaceholder = "Default Placeholder";
export const Select2singleselect = "Select2 single select";
export const Select2multiselect = "Select2 multi select";
export const RTLsupport = "RTL support";
export const LimitingRTLsupport = "Limiting The Number Of Selections";
export const DisabledResults = "Disabled Results";
export const HidingTheSearchBox = "Hiding The Search Box";
export const EnableDisable = "Enable-Disable";
export const Enable = "Enable";
export const Disable = "Disable";
export const PrimarySelect = "Primary Select";
export const SecondarySelect = "Secondary Select";
export const SuccessSelect = "Success Select";
export const InfoSelect = "Info Select";
export const WarningSelect = "Warning Select";
export const DangerSelect = "Danger Select";
export const InverseSelect = "Inverse Select";

export const Basicswitch = "Basic Switch";
export const SwitchColor = "Switch Color";
export const Switchoutline = "Switch Outline";
export const SwitchUncheckedOutline = "Switch Unchecked Outline";
export const Switchsizing = "Switch Sizing";
export const SwitchWithIcon = "Switch With Icon";
export const SwitchWithcolor = "Switch With Color";

export const CopyPortionParagraph = "Copy Portion From Paragraph";
export const Loremipsum = "Lorem ipsum";
export const Loremipsum2 = ", consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
export const Cutandcopytext = "Cut/copy from text input";
export const Copy = "Copy";
export const Cut = "Cut";
export const ClipboardonText = "Clipboard On Text Input";
export const ClipboardOnTextarea = "Clipboard On Textarea";
export const Cutandcopytextarea = "Cut/copy from textarea";
export const Clipboardon = "Clipboard On Paragraph";
export const CopyParagraph = "Copy from Paragraph";
export const Copyhighlighte = "Copy highlighted text";

export const CustomRadio = "Custom Radio";
export const Option = "Option";
export const Checked = "Checked";
export const RadioStates = "Radio states";
export const InlineCheckbox = "Inline checkbox";
export const CustomCheckbox = "Custom checkbox";
export const CheckboxStates = "Checkbox states";
export const SuccessState = "Success state";
export const BrandState = "Brand state";
export const PrimaryState = "Primary state";
export const InfoState = "Info state";
export const AnimatedRadioButtons = "Animated radio buttons";
export const AnimatedCheckboxButtons = "Animated checkbox buttons";
export const SquareCheckbox = "Square checkbox";
export const SolidCheckbox = "Solid checkbox";
export const DefaultTouchspint = "Default Touchspin";
export const touchspin = ".touchspin";
export const touchspintext = "class to input to add touchspin input group.";

export const VerticalTouchspin = "Vertical Touchspin";
export const touchspin_verticald = ".touchspin-vertical";
export const VerticalText = "class for vertical touchspin input group.";

export const BasicInputGroups = "Basic Input groups";
export const LeftAddon = "Left Addon";
export const RightAddon = "Right Addon";
export const JointAddon = "Joint Addon";
export const LeftRightAddon = "Left & Right Addon";
export const SolidStyle = "Solid style";
export const SquareStyle = "Square style";
export const RaiseStyle = "Raise style";
export const FlatStyle = "Flat style";
export const SelectDefault = "Open this select menu";
export const One = "One";
export const Two = "Two";
export const Three = "Three";
export const EstimatedTime1 = "Estimated 14-20 Day Shipping ( Duties end tax may be due upon delivery)";
export const EstimatedTime2 = "Estimated 1 Day Shipping ( Duties end tax may be due upon delivery)";
export const EstimatedTime3 = "Estimated 15 Day Shipping ( Duties end tax may be due upon delivery)";
export const EstimatedTime4 = "Estimated 3 to 5 Day Shipping ( Duties end tax may be due delivery)";

export const DefaultStyle = "Default Style";
export const DefaultStylepara = "This option is show buydefault you don't need to add any extra class";
export const Fast = "Fast";
export const NoBorder = "No Border";
export const NoBordertext = "By adding .plain-style class to .mega-inline You can archive this style";
export const SolidBorderStyle = "Solid Border Style";
export const SolidBordertext = "By adding .border-style class to .mega-inline You can archive this style";
export const OfferStyleBorder = "Offer style Border";
export const InlineStyle = "Inline Style";
export const InlineStyletext = "For Create inline megaoption add";
export const InlineStyletext2 = "class in form tag";
export const mega_inlined = ".mega-inline";
export const mega_horizontald = ".mega-horizontal";
export const Local = "Local";
export const VerticalStyle = "Vertical Style";
export const VerticalStyleText = "For Create inline megaoption add";
export const megaverticald = ".mega-vertical";
export const DeliveryOption = "Delivery Option";
export const BuyingOption = "Buying Option";
export const XYZSeller = "XYZ Seller";
export const ABCSeller = "ABC Seller";
export const HorizontalStyle = "Horizontal Style";
export const Seller = "Seller";
export const INR50 = "50 INR";
export const INR80 = "80 INR";
export const INR100 = "100 INR";
export const INR150 = "150 INR";
export const INR250 = "250 INR";
export const DefaultText = "Estimated 1 Day Shipping ( Duties end tax may be due delivery )";
export const Tooltiptext = "If your form layout allows it, you can swap the";
export const Tooltiptext2 = "classes to display validation feedback in a styled tooltip. Be sure to have a parent with";
export const Tooltiptext3 = "on it for tooltip positioning. In the example below, our column classes have this already, but your project may require an alternative setup.";
export const feedbackd = ".feedback";
export const classesfor = ".feedback";
export const tooltipd = ".tooltip";
export const positionrelative = "position: relative";
export const StarRating1 = "1 star rating";
export const StarRating5 = "5 star rating";

export const DatePickers = "Date Picker";
export const SelectDateWithTime = "Select Date with Time";
export const SelectTimeOnly = "Select Time Only";
export const CustomDateFormat = "Custom date format";
export const TodayButton = "Today button";
export const DisableDaysOfWeek = "Disable days of week";
export const SpecificDateRange = "Specific date range";
export const MinDate = "Min date";
export const MaxDate = "Max date";
export const DateRange = "Date Range";
export const DisableDatepicker = "Disable Datepicker";
export const InlineVersion = "Inline version";

export const TimePickerDarkTheme = "Time Picker with Dark Theme";
export const SetClassicTheme = "Set Classic Theme";
export const SetMultipleTimepicker = "Set Multiple Timepicker";
export const SingleDatePicker = "Single Date Picker";
export const SingleDateText = "The Date Range Picker can be turned into a single date picker widget with only one calendar. In this example, dropdowns to select a month and year have also been enabled at the top of the calendar to quickly jump to different months.";
export const InputInitiallyEmpty = "Input Initially Empty";
export const InputEmptyteaxt = "If you're using a date range as a filter, you may want to attach a picker to an input but leave it empty by default. This example shows how to accomplish that using the";
export const InputEmptyteaxt2 = " setting, and the ";
export const autoUpdateInput = "autoUpdateInput";
export const eventsd = "events.";

export const BasicDemo = "Basic Demo";
export const MultipleSelections = "Checked";
export const CustomSelections = "Custom Selections";
export const Remote = "Remote";
export const Basicformtext = "Hello !... This is static text";
export const BasicText = "This is the simple demo for Typeahead.";
export const RemoteText = "Remote data is only used when the data provided by local and prefetch is insufficient";
export const Clear = "Clear";
export const Focus = "Focus";
export const FocusbtnText = "Focus, then blur after 1 second";
export const DateTimePicker = "Date Time Picker";
export const DateOnly = "Date Only";
export const TimeOnly = "Time Only";
export const UsingLocales = "Using Locales";
export const MinimumSetup = "Minimum Setup";
export const DateRangePicker = "Date Range Picker";
export const DateRangeText = "The Date Range Picker use the current value of the input to initialize, and update the input if new dates are chosen.";
export const PredefinedRanges = "Predefined Ranges";
export const PredefinedText = "This example shows the option to predefine date ranges that the user can choose from a list.";

export const DefaultFormLayout = "Default Form Layout";
export const HorizontalFormLayout = "Horizontal Form Layout";
export const MegaForm = "Mega form";
export const AccountInformation = "Account Information";
export const CompanyInformation = "Company Information";
export const BillingInformation = "Billing Information";
export const InlineForm = "Inline Form";
export const InlineFormWithLabel = "Inline Form with Label";
export const InlineFormWithoutLabel = "Inline Form without Label";
export const InlineFormspan = "class in the form to style with inline fields.";
export const forminline = ".form-inline";

export const Login = "Login";
export const LoginAs = "Login As";
export const LOGIN = "LOGIN";
export const CompanyName = "Company Name";
export const ContactNumber = "Contact Number";
export const ContactNo = "Contact No.";
export const Radios = "Radios";
export const Checkboxes = "Checkboxes";

export const FormWizardWithIcon = "Form Wizard With Icon";
export const ConfirmPassword = "Confirm Password";
export const DD = "DD";
export const MM = "MM";
export const YY = "YY";

export const ButtonDiscription = "Button Discription";
export const DifferentButtonstyle = "Different Button style";
export const ButtonStyle = "Button Style";


export const OpeningBalance = "Opening Balance";
export const BankNameText = "Bank Name";
export const Suspend = "Suspend";
export const BankNo = "Bank Phone no.";
export const BankAddress = "Bank Address";
export const AccountNo = "Account No";
export const AddedBy = "Added by";
export const CurrencyCode = "Currency Code";
export const BankNameError = "Bank name is required";
export const BankNoError = "Bank phone number is required";
export const BankAddressError = "Bank address is required";
export const AccountNoError = "Bank account number is required";
export const OpeningBalanceError = "Opening balance is required";
export const CurrencyCodeError = "Currency code is required";
export const PriceCalculation = "Price Calculation";
export const SetupCost = "Setup Cost";
export const ExpiryDate = "Expiry Duration";
export const Days = "Days";
export const SMSActive = "SMS Activate";
export const whatsAPP = "WhatsApp Activate";
export const FeaturesError = "Features is required";
export const DiscriptionError = "Description is required";
export const PriceError = "Price is required";
export const MrpError = "Mrp is required";
export const MaxError ="Max Connection is required"
export const MinError ="Min Connection is required"
export const PriceCalError ="Price Calculation is required"
export const TaxGroupError = "Tax Class is required";
export const IndustryError = "Select an industry";
export const SetupCostError = "Setup cost is required";
export const ExpiryDateError = "Expiry Duration is required";
export const DaysError = "Days is required";
export const HSNError="HSN is required"
export const HSN = "HSN";
export const SmsStatus = "SMS Status";

//  tables
export const BasicTable = "Basic Table";
export const TaxClass = "Tax Class";
export const TaxGroup = "Tax Group";
export const InverseTable = "Inverse Table";
export const InverseTablePrimaryBackground = "Inverse Table with Primary background";
export const HoverableRows = "Hoverable rows With Horizontal Border";
export const TextBackgroundUtilities = "Text or background utilities";
export const TableHeadOptions = "Table head options";
export const TableHeadspan = "Similar to tables and dark tables, use the modifier classes";
export const theadlight = ".thead-light";
export const tomake = "to make";
export const thead = "thead ";
export const theadtext = "appear light or dark gray.";
export const StripedRow = "Striped Row";
export const StripedRowInverseTable = "Striped Row with Inverse Table";
export const Caption = "Caption";
export const ResponsiveTables = "Responsive Tables With Light Background";
export const BreckpointSpecific = "Breckpoint Specific";

export const ExtraLargeTables = "Extra Large Tables";
export const LargeTable = "Large Table";
export const DefaultTable = "Default Table";
export const SmallTable = "Small table";
export const ExtraSmallTable = "Extra Small table";
export const HorizontalBorders = "Horizontal Borders";
export const VerticalBorders = "Vertical Borders";
export const BothBordeds = "Both Bordeds";
export const BorderlessTable = "Borderless Table";
export const DefaultTableBorder = "Default Table Border";
export const SolidBorder = "Solid Border";
export const DoubleBorder = "Double Border";
export const DottedBorder = "Dotted Border";
export const DashedBorder = "Dashed Border";
export const BorderBottomColor = "Border Bottom Color";
export const DefultStyling = "Defult Styling";
export const TableFooterStyling = "Table Footer Styling";
export const TableHeadOptionsPrimaryBackground = "Table head options With Primary Background";
export const CustomTableColor = "Custom Table Color";
export const CustomTableColorHoverStripped = "Custom Table Color with Hover and Stripped";

// pages
export const RememberPassword = "Remember password";
export const ForgotPassword = "Forgot password?";
export const SignIn = "Sign In";
export const SignUp = "Sign Up";
export const CreateAccount = "Create Account";
export const CreateyourAccount = "Create your account";
export const CreateyourPassword = "Create Your Password";
export const CreateAccounttext = "Enter your personal details to create account";
export const Authtext = "Welcome to login with Auth0";
export const Authpara = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy";
export const orSigninwith = "Or Sign in with";
export const signinaccount = "Sign in to account";
export const EmailPassword = "Enter your email & password to login";
export const Donthaveaccount = "Don't have account?";
export const Alreadyhaveaccount = "Already have an account?";
export const AlreadyhavePassword = "Already have an password?";
export const Maintanancetext1 = "Our Site is Currently under maintenance We will be back Shortly";
export const Maintanancetext2 = "                Thank You For Patience";
export const CommingSoontext = "Let's Get Started With ";
export const KOHO = "KOHO";

export const EnterPassword = "Enter your Password";
export const Unlock = "Unlock";
export const CREATEPASSWORD = "CREATE YOUR PASSWORD";
export const RetypePassword = "Retype Password";
export const NewPassword = "New Password";
export const Wearecomingsoon = "We Are Coming Soon";

export const ResetPassword = "Reset Your Password";
export const EnterMobileNumber = "Enter Your Mobile Number";
export const EnterOTP = "Enter OTP";
export const Ifdontrecieveotp = "If don't receive OTP?";
export const Resend = "Resend";
export const MAINTENANCE = "MAINTENANCE";
export const BACK_TO_HOME_PAGE = "BACK TO HOME PAGE";
export const WE_ARE_COMING_SOON = "WE ARE COMING SOON";

export const SampleCard = "Sample Card";
export const Videos = "Videos";
export const Images = "Images";
export const SearchSetting = "Search setting";
export const Language = "Language";
export const Shopping = "Shopping";
export const Billing = "Billing";
export const Getting = "Getting";
export const Flights = "Flights";
export const CubaEducationInfo = "Cubaeducation.info/";
export const Tools = "Tools";

export const Basicemailtext = "333 Woodland Rd. Baldwinsville, NY 13027";
export const Basicemailpara = "Don't Like These Emails?";
export const Unsubscribe = "Unsubscribe";
export const PoweredByKoho = "Powered By Koho Admin";
export const GoodluckHope = "Good luck! Hope it works.";
export const Basicemailpara1 = "This is a really simple email template. It's sole purpose is to get the recipient to click the button with no distractions.";
export const Basicemailpara2 = "Sometimes you just want to send a simple HTML email with a simple design and clear call to action.";
export const HiThere = "Hi There,";
export const SomeDescription = "Some Description";

// gallery
export const IMAGE_GALLERY = "IMAGE GALLERY";
export const IMAGE_GALLERYDEC = "IMAGE GALLERY WITH DESCRIPTION";
export const HoverEffect = "Hover Effect";
export const MasonryGalleryWithDescription = "MASONRY GALLERY WITH DESCRIPTION";
export const MASONRYGALLERY = "MASONRY GALLERY";
export const Imagedesc = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";

// blog
export const JolioMark = "Jolio Mark";
export const PostEdit = "Post Edit";
export const Type = "Type";
export const Text = "Text";
export const Image = "Image";
export const Audio = "Audio";
export const Video = "Video";
export const Category = "Category";
export const Content = "Content";
export const Post = "Post";
export const Discard = "Discard";
export const Blogimgdate = "25 July 2023";
export const singleblogpara = "Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.";
export const singleblogcontent =
  "Knowledge can be produced in many different ways. The most important source is perception, which refers to the usage of the five senses. Many theorists also include introspection as a source of knowledge, not of external physical objects, but of ones own mental states. Other sources often discussed include memory, rational intuition, inference, and testimony. According to foundationalism, some of these sources are basic in the sense that they can justify beliefs without depending on other mental states. This claim is rejected by coherentists.";

// job search
export const UIDesigner = "UI Designer";
export const KohoTelecom = "Koho Telecom & Technologies , NY ";
export const Fulltime8688 = "Full-time (8688)";
export const Contract = "Contract";
export const Parttime = "Part-time";
export const Internship = "Internship";
export const Temporary = "Temporary";
export const Commission = "Commission";

export const PersonalDetails = "Personal Details";
export const FullName = "Full Name";
export const RepeatPassword = "Repeat Password";
export const BirthDate = "Birth Date";
export const PhoneNumber = "Phone Number";
export const CollegeName = "College Name";
export const Period = "Period";
export const DegreeLevel = "Degree Level";
export const Specialization = "Specialization";
export const YourExperience = "Your Experience";
export const YourEducation = "Your Education";
export const UploadCoverLetter = "Upload Cover Letter";
export const UploadYourCV = "Upload Your CV";
export const UploadRecommendations = "Upload Recommendations";
export const UploadYourFiles = "Upload Your Files";

export const JobDetaildec =
  "We are looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. Our designers contribute to clients’ projects at all stages of development. We might start from scratch, conducting user and stakeholder interviews, making personas and journey maps, and continue on to iterating o esigns and prototypes through delivering final assets for launch. We might come into the middle of an in-flight program-size project and conduct analysis and usability correction or feature enhancement. We might provide research and vision for handoff to an internal development team.";

export const CreativeUnitedStates = "Creative - United States";
export const JobDescription = "Job Description";
export const Qualifications = "Qualifications";
export const qualifytext1 = "Have shipped multiple iOS, Android, and/or web products ";
export const qualifytext2 = "5+ years UI/UX experience";
export const qualifytext3 = "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles";
export const qualifytext4 = "Ability to autonomously pursue elegant solutions to open-ended problems";
export const qualifytext5 = "Comfort with ambiguity";
export const qualifytext6 = "ively work on more than one project at a time";
export const qualifytext7 = "Experience conducting user research and stakeholder interviews";
export const qualifytext8 = "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.";
export const qualifytext9 = "Bonus Considerations ";
export const AgencyExperience = "Agency experience";
export const AgencyExptext1 = "Experience working with Agile development teams";
export const AgencyExptext2 = "Experience with RITE method usability testing";
export const AgencyExptext3 = "Experience in visual and motion design; ability to translate UX design into high quality visuals";
export const AgencyExptext4 = "Mastery of Sketch & InVision";
export const AgencyExptext5 = "Knowledge of mobile or front-end web programming";
export const Perks = "Perks";
export const Perkstext1 = "Competitive pay";
export const Perkstext2 = "Competitive medical, dental, and vision insurance plans";
export const Perkstext3 = "-proviCompanyded 401(k) plan";
export const Perkstext4 = "Paid vacation and sick time";
export const Perkstext5 = "Free snacks and beverages";
export const Savethisjob = " Save this job";
export const SimilarJobs = "Similar jobs";
export const SeniorUXDesigner = "Senior UX designer";
export const share = "Share";
export const SearchImageTime = "25 July 2022";
export const SearchDesc = "People just dont do it anymore. We have to change that. Sometimes the simplest things are the most profound.";
export const Hits = "02 Hits";
export const Hits15 = "15 Hits";
export const Comments = "598 Comments";
export const BlogDate = "January 2023";
export const Blogdcs = "Dressing is a way of life.";
export const Blogpara = "A huge part of it is the incomparable beauty you can encounter every day.";
export const Bloggallaryimg = "Dressing is a way of life.";
export const Bloggallaryimgpara = "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.";
export const byPaigeTurner = "by: Paige Turner";
export const byPeteyCruiser = "by: Petey Cruiser";
export const learningtext = "inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.";
export const learningdetailtext = "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.";

export const FrontEndWebDeveloper = "Front end web developer";
export const GraphicDesigner = "Graphic designer";
export const DesignerCRM = "Designer, CRM";
export const UIDesigner_E_commerce = "UI designer E-commerce";
export const ReactandReact_Native_Developer = "React/React Native Developer";
export const UIandUX_IT_Frontend_Developer = "UI/UX IT Frontend Developer";
export const Frontenddesigner = "Front end designer";
export const PHPdeveloper = "PHP developer";
export const ReactDeveloper = "React Developer";

export const ComputerSoftware = "Computer Software";
export const ITEngineer = "IT Engineer";
export const Serviceindustry = "Service industry";
export const FinancialServices = "Financial Services";
export const htmlcss = "HTML,scss & sass";
export const Javascript = "Javascript";
export const Nodejs = "Node.js";
export const GulpPug = "Gulp & Pug";
export const Angularjs = "Angular.js";

export const FindJobs = "Find jobs";
export const NewYork = "New York";
export const India = "India";
export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const AllLocations = "All Locations";
export const AllJobTitle = "All Job Title";
export const JobTitle = "Job Title";
export const Industry = "Industry";
export const TaxPer = "Tax %";
export const AllIndustries = "All Industries";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const UIUxdesigner = "UI/Ux designer(25)";

export const FindCourse = "Find Course";
export const Categories = "Categories";
export const Accounting = "Accounting";
export const Design = "Design";
export const Development = "Development";
export const Management = "Management";
export const Duration = "Duration";
export const AllCourses = "All Courses";
export const PaidCourses = "Paid Courses";
export const FreeCourses = "Free Courses";
export const Registration = "Registration";
export const Progress = "Progress";
export const Completed = "Completed";
export const Filter = "Filter";
export const UIDesign = "UI Design";
export const UXDesign = "UX Design";
export const InterfaceDesign = "Interface Design";
export const UserExperience = "User Experience";
export const FrontendDevelopment = "Frontend Development";
export const BackendDevelopment = "Backend Development";
export const UpcomingCourses = "Upcoming Courses";
export const UXDevelopment = "UX Development";
export const BusinessAnalyst = "Business Analyst";
export const WebDevelopment = "Web Development";
export const CourseBy = "Course By";
export const JavaLanguage = "Java Language";

// maps
export const CurrentLocation = "Current Location";
export const MarkerMap = "Marker Map";
export const Polygons = "POLYGONS";
export const Polylines = "Polyline";

export const GeoJsonMapDemo = "GeoJsonMap Demo";
export const AnimateMap = "Animate Map";
export const AnimatePanning = "Animate panning";
export const SetMarkerWithPopup = "Set Marker with Popup";
export const LeafletWORLDMAP = "Leaflet World Map";
export const LeafletMAPspan = "Below Map is displaying the world map.";
export const LeafletUKMAP = "Leaflet UK Map";
export const LeafletUKMAPspan = "Below Map is displaying the UK map.";
export const LeafletIndiaMAP = "Leaflet India map";
export const LeafletIndiaMAPspan = "Below Map is displaying the India map.";
export const LeafletAustraliaMAP = "Leaflet Australia map";
export const LeafletAustMAPspan = "Below Map is displaying the Australia map.";
export const PopupinFeatureGroup = "Popup in FeatureGroup";

// editors
export const CKEditorExample = "CK Editor Example";
export const JavascriptMode = "Javascript Mode";
export const HtmlMode = "Html Mode";
export const CssMode = "css Mode";
export const PhpMode = "php Mode";
export const MDEEditorExample = "MDE Editor Example";
export const Yourtitle = "Your title";
export const CkTitlepara = "Inline Editing is a feature that allows users to seamlessly edit and write content visually and directly on-screen without having to toggle between a ‘read-only’ view and an ‘edit’ view. In short, users can make quick changes or create content without going to a new page.";
export const InlineEditor = "Inline Editor";
export const MNDeditortext = "Enter text in the area on the left. For more info, click the ? (help) icon in the menu.";
export const Instructions = "Instructions";
export const SecondExample = "Second Example";

// faq anf knowledgebase
export const Articles = "Articles";
export const Knowledgebase = "Knowledgebase";
export const Support = "Support";
export const IntellectualProperty = "Intellectual Property";
export const SellingAndBuying = "Selling And Buying";
export const UserAccounts = "User Accounts";
export const SearchArticles = "Search Articles";
export const Navigation = "Navigation";
export const LatestUpdates = "Latest Updates";
export const WhychooseKnowledge = "Why Choose Knowledge Course ?";

export const DavidLinner = "David Linner";
export const UserChristopher = "User Christopher";
export const AskQuestion = "Ask Question";
export const Tutorials = "Tutorials";
export const HelpCenter = "Help center";
export const VideoTutorials = "Video Tutorials";

export const AskOurCommunity = "Ask our community";
export const VictoriaWilson = "Victoria Wilson";
export const FeaturedTutorials = "Featured Tutorials";
export const WebDesign = "Web Design";
export const SeeAll = "See All";
export const BrowseArticles = "Browse Articles";
export const HowCanIhelpyou = "How Can I help you?";
export const knowledgearticl = "knowledge articles by category";
export const KnowledgeCategories = "Knowledge Categories";
export const QuickQuestions = "Quick Questions are answered";
export const Faqpara = "How you approach this process will depend on which web host you use. For example, a lot of hosting providers use cPanel, which includes an option to set up subdomains with just a few clicks.";
export const Latestarticles = "Latest articles and videos";

// layout
export const Loading = "Loading...";
export const BonusUi = "Bonus Ui";
export const MegaMenu = "Mega menu";
export const ErrorPage = "Error Page";
export const Authentication = "Authentication";
export const UsefullPages = "Usefull Pages";
export const ComingSoon = "Coming Soon";
export const Pagenotfound = "Page Not Found";
export const ErrorPageContent = "The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved.";
export const Error2Head = "Oops! This Page is Not Found.";
export const Error3Head = "Sorry, Something Goes Wrong";
export const Error4Head = "Internal Server Error";

export const English = "English";
export const Deutsch = "Deutsch";
export const Español = "Español";
export const Français = "Français";
export const Português = "Português";
export const 简体中文 = "简体中文";
export const DeliveryProcessing = "Delivery processing";
export const OrderComplete = "Order Complete";
export const TicketsGenerated = "Tickets Generated";
export const DeliveryComplete = "Delivery Complete";
export const CheckAllNotification = "Check all notification";
export const ShopingBag = "Shoping Bag";
export const OrderTotal = "Order Total";
export const GoToShopingBag = "Go to shoping bag";
export const SupportTicket = "Support Ticket";
export const Apps = "Apps";
export const TicketListhead = "Ticket List";
export const TicketListspan = "List of ticket opend by customers";

export const ViewCart = "View Cart";
export const MessageBox = "Message Box";
export const KoriThomas = "Kori Thomas";
export const Koho = "Koho";
export const BillerQ = "BillerQ";
export const Kohoemail = "hello@koho.in";
export const AinChavez = "Ain Chavez";
export const ViewAll = "View All";
export const Admin = "Admin";
export const Account = "Account";
export const AccountList = "Account List";
export const Taskboard = "Taskboard";

export const QuickOption = "Quick option";
export const Document = "Document";
export const CheckFeatures = "Check features";
export const Features = "Features";
export const UnlimitedColor = "Unlimited Color";
export const Apply = "Apply";
export const Customizer = "Customizer";
export const Customize = "Customize";
export const PreviewRealTime = "Preview Real Time";
export const Configuration = "Configuration";
export const CopyText = "Copy text";
export const layoutType = "Layout Type";
export const LTR = "LTR";
export const RTL = "RTL";
export const Box = "Box";
export const SidebarType = "Sidebar Type";
export const SidebarSettings = "Sidebar settings";
export const Border = "Border";
export const IconColor = "icon Color";
export const PreviewSettings = "Preview Settings";
export const TryItRealTime = "Try It Real Time";

export const RouterAnimation = "Router Animation";
export const ZoomFade = "Zoom Fade";
export const SildeFade = "Silde Fade";
export const FadeBottom = "Fade Bottom";
export const Fade = "Fade";
export const ZoomOut = "Zoom Out";
export const None = "None";
export const LightLayout = "Light layout";
export const DarkLayout = "Dark Layout";
export const MixLayout = "Mix Layout";

export const LevelMenu = "Level Menu";
export const FileManager = "File manager";
export const UserProfile = "User Profile";
export const UserEdit = "User Edit";
export const UsersCards = "Users Cards";
export const KanbanBoard = "Kanban Board";
export const SocialApp = "Social App";
export const Bookmark = "Bookmark";
export const AddNewBookmark = "Add New Bookmark";
export const Back = "Back";

export const Addrole = "Add role";
export const EditRole = "Edit role";
export const MinmumConnection = "Minimum connection";
export const MaximumConnection = "maximum connection";
export const InvoicePayment = "Invoice Payment";
export const InvoicePaymentAdd = "Add Invoice Payment";
export const totalPending = "Total Pending";
export const PaymentMethod = "Payment Method";
export const DateText = "Date";
// export const MaximumConnection = "maximum connection";
export const Invoicetotal = "Invoice Total";

//notification-channel
export const channelType = "Channel Type";
export const unitRate = "Unit Rate";
export const charLimit = "Char Limit";



